import React from "react";
import { Container } from "@mui/material";

import "./EulaBCP.css";

export default function EulaBCP() {
  return (
    <Container
      className="eulaContainer"
      sx={{
        paddingTop: 2,
        paddingBottom: 2,
      }}
      maxWidth="lg"
    >
      <div>
        <p class="c13 c10">
          <span class="c2"></span>
        </p>
      </div>
      <p class="c18">
        <span class="c3">Best Coast Pairings LLC</span>
      </p>
      <p class="c18">
        <span class="c3">Website and Services Terms of Use</span>
      </p>
      <p class="c4">
        <span class="c7">Last Modified: </span>
        <span>1.24.22</span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <p class="c4" id="h.gjdgxs">
        <span class="c7">
          These terms of use are entered into by and between you and Best Coast
          Pairings LLC (&ldquo;
        </span>
        <span class="c7 c9">Company</span>
        <span class="c7">&rdquo;, &ldquo;</span>
        <span class="c7 c9">we</span>
        <span class="c7">&rdquo; or &ldquo;</span>
        <span class="c7 c9">us</span>
        <span class="c7">&rdquo;). The following terms and conditions, </span>
        <span>
          together with any documents they expressly incorporate by reference
          (collectively, these &ldquo;
        </span>
        <span class="c9">Terms of Use</span>
        <span>&rdquo;), </span>
        <span class="c7">
          govern your access to and use of BestCoastPairings.com (the &ldquo;
        </span>
        <span class="c7 c9">Website</span>
        <span class="c7">
          &rdquo;), including any content, functionality and services offered on
          or through BestCoastPairings.com, including access to and use of the
          Company&rsquo;s mobile applications (the &ldquo;
        </span>
        <span class="c7 c9">Services</span>
        <span class="c2">
          &rdquo;), whether as a guest or a registered user.
        </span>
      </p>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0 start" start="1">
        <li class="c1">
          <span class="c3">ACCEPTANCE OF THE TERMS OF USE.</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c7">
          Please read the Terms of Use carefully before you start to use the
          Services.{" "}
        </span>
        <span class="c7 c9">
          By clicking to accept or agree to the Terms of Use when this option is
          made available to you, you accept and agree to be bound and abide by
          these Terms of Use and our{" "}
        </span>
        <span class="c6">Privacy Policy</span>
        <span class="c7 c9">, found at </span>
        <span class="c16 c9 c17">
          <a
            class="c21"
            href="https://www.google.com/url?q=https://www.bestcoastpairings.com/privacy&amp;sa=D&amp;source=editors&amp;ust=1643111868080061&amp;usg=AOvVaw1rcyOWTI9taccl4Oni_Ujo"
          >
            https://www.bestcoastpairings.com/privacy
          </a>
        </span>
        <span class="c9">&nbsp;</span>
        <span class="c7 c9">, incorporated herein by reference.</span>
        <span class="c2">
          &nbsp;If you do not want to agree to these Terms of Use or the Privacy
          Policy, you must not access or use the Services.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          The Services are offered and available to users who are 16 years of
          age or older. By using the Services, you represent and warrant that
          you are of legal age to form a binding contract with the Company, or
          if you are under 16 years of age, your parent or legal guardian has
          accepted this Agreement on your behalf. If you do not meet all of
          these requirements, you must not access or use the Services.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="2">
        <li class="c1">
          <span class="c3">CHANGES TO THE TERMS OF USE.</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          We may revise and update these Terms of Use from time to time in our
          sole discretion. All changes are effective immediately when we post
          them on our Website, and apply to all access to and use of the
          Services thereafter.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          Your continued use of the Services following the posting of revised
          Terms of Use means that you accept and agree to the changes. You are
          expected to check this page from time to time so you are aware of any
          changes, as they are binding on you.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="3">
        <li class="c1">
          <span class="c3">ACCESSING THE WEBSITE AND ACCOUNT SECURITY.</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          We reserve the right to withdraw or amend the Services in our sole
          discretion without notice. We will not be liable if for any reason all
          or any part of the Services are unavailable at any time or for any
          period. From time to time, we may restrict access to some parts of the
          Services, including, without limitation, the entire Website, to users,
          including registered users.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          If you are a tournament organizer or other entity responsible for
          providing access to the Services (including mobile applications) to
          users you agree that you are responsible for:
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_1-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Making all arrangements necessary for users to have access to the
            Services.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_2-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Ensuring that all persons who access the Website through your
            internet connection or device are aware of these Terms of Use and
            comply with them.
          </span>
        </li>
      </ol>
      <p class="c4 c15 c10">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c7">
          To access the Services, you may be asked to provide certain
          registration details or other information. It is a condition of your
          use of the Services that all the information you provide to the
          Company is correct, current and complete. You agree that all
          information you provide to register for the Services, including but
          not limited to through the use of any interactive features or
          subscriptions services on the Website, is governed by our{" "}
        </span>
        <span class="c7 c14">Privacy Policy</span>
        <span class="c7">&nbsp;</span>
        <span>https://www.bestcoastpairings.com/privacy</span>
        <span class="c2">
          , and you agree that all actions we take with respect to your
          information consistent with our Privacy Policy are taken by us to
          comply with our contractual obligations to you in providing the
          Services.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          If you choose, or are provided with, a user name, password or any
          other piece of information as part of our security procedures, you
          must treat such information as confidential, and you must not disclose
          it to any other person or entity. You also acknowledge that your
          account is personal to you and agree not to provide any other person
          with access to this Website or portions of it using your user name,
          password or other security information. You agree to notify us
          immediately of any unauthorized access to or use of your user name or
          password or any other breach of security. You also agree to ensure
          that you exit from your account at the end of each session. You should
          use particular caution when accessing your account from a public or
          shared computer so that others are not able to view or record your
          password or other personal information.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          We have the right to disable any user name, password or other
          identifier, whether chosen by you or provided by us, at any time if,
          in our opinion, you have violated any provision of these Terms of Use.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="4">
        <li class="c1">
          <span class="c3">INTELLECTUAL PROPERTY RIGHTS.</span>
          <span class="c2">
            &nbsp; The Services and entire contents, features and functionality
            (including but not limited to all information, software, text,
            displays, images, video and audio, and the design, selection and
            arrangement thereof), are owned by the Company, its licensors or
            other providers of such material and are protected by United States
            and international copyright, trademark, patent, trade secret and
            other intellectual property or proprietary rights laws (&ldquo;
          </span>
          <span class="c3">Intellectual Property Rights</span>
          <span class="c2">
            &rdquo;). &nbsp;You acknowledge and agree that the Company (and/or
            its licensors) exclusively own all right, title and interest in and
            to the Services, copyright rights, trade secret rights, trademarks,
            database rights and any other intellectual property rights anywhere
            in the world. &nbsp;Nothing in these Terms of Use or the Services
            should be construed as granting, by implication, estoppel or
            otherwise, any license or right to use any of the Company&rsquo;s
            logos, trademarks or information displayed on the Website, without
            the Company&rsquo;s prior written permission in each instance.
            &nbsp;All goodwill generated from the use of the Company&rsquo;s
            trademarks will{" "}
          </span>
          <span>insure</span>
          <span class="c2">&nbsp;to our exclusive benefit.</span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_46-1 start" start="1">
        <li class="c11">
          <span class="c3">License to Services.</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          These Terms of Use permit you to use the Services, and anything
          available through the Website, for your personal, non-commercial use
          only. Unless you have entered a written agreement with the Company
          providing otherwise, you must not reproduce, distribute, modify,
          create derivative works of, publicly display, publicly perform,
          republish, download, store or transmit any of the material on our
          Website, except as follows:
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_3-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Your computer may temporarily store copies of such materials in RAM
            incidental to your accessing and viewing those materials.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_4-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            You may store files that are automatically cached by your Web
            browser for display enhancement purposes.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_5-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            You may print one copy of a reasonable number of pages of the
            Website for your own personal, non-commercial use and not for
            further reproduction, publication or distribution.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_6-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            If we provide desktop, mobile or other applications for download,
            you may download the mobile application(s) provided you agree to be
            bound by the applicable End User License Agreement for such
            applications.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_7-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            If we provide social media features with certain content, you may
            take such actions as are enabled by such features.
          </span>
        </li>
      </ol>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c2">
          Unless you have the Company&rsquo;s permission, you must not:
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_8-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Modify copies of any materials or information from this site.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_9-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Use any illustrations, photographs, video or audio sequences or any
            graphics separately from the accompanying text.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_10-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Delete or alter any copyright, trademark or other proprietary rights
            notices from copies of materials from this site.
          </span>
        </li>
      </ol>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c2">
          If you print, copy, modify, download or otherwise use or provide any
          other person with access to any part of the Services in breach of the
          Terms of Use, your right to use the Services will cease immediately
          and you must, at our option, return or destroy any copies of the
          materials you have made. No right, title or interest in or to the
          Services or any content on the Website is transferred to you, and all
          rights not expressly granted are reserved by the Company. Any use of
          the Services not expressly permitted by these Terms of Use is a breach
          of these Terms of Use and may violate copyright, trademark and other
          laws.
        </span>
      </p>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-1" start="2">
        <li class="c11">
          <span class="c3">Feedback.</span>
        </li>
      </ol>
      <p class="c13">
        <span class="c2">
          To the extent that you give us feedback, comments or suggestions
          concerning the Services (collectively, &ldquo;Feedback&rdquo;), you
          acknowledge and agree that all Feedback is the Company&rsquo;s sole
          and exclusive property, and you hereby unconditionally and irrevocably
          assign and transfer to Best Coast Pairings, your entire right, title
          and interest in and to any Intellectual Property Rights that you may
          now or hereafter have in or relating to the Services. &nbsp;To the
          extent that the foregoing assignment is ineffective for whatever
          reason, you agree to grant and hereby grant to the Company a
          non-exclusive, perpetual, irrevocable, royalty-free, worldwide license
          (with the right to grant and authorize sublicenses) to make, have
          made, use, import, offer for sale, sell, reproduce, distribute,
          modify, adapt, prepare derivative works of, display, perform, and
          otherwise exploit such Feedback without restriction. &nbsp;At our
          request and expense, you will execute documents and take such further
          acts as we may reasonably request to assist us in acquiring,
          perfecting and maintaining our Intellectual Property Rights in, and
          other legal protections for, the Feedback.
        </span>
      </p>
      <p class="c4 c10">
        <span class="c12 c7 c9"></span>
      </p>
      <ol class="c8 lst-kix_list_46-1" start="3">
        <li class="c11">
          <span class="c3">Trademarks.&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          The Company name, the Company logo and all related names, logos,
          product and service names, designs and slogans are trademarks and
          service marks of the Company or its affiliates or licensors. You must
          not use such marks without the prior written permission of the
          Company. All other names, logos, product and service names, designs
          and slogans used on this Website or in the Services are the trademarks
          and/or service marks of their respective owners.
        </span>
      </p>
      <p class="c4 c10">
        <span class="c12 c7 c9"></span>
      </p>
      <ol class="c8 lst-kix_list_46-1" start="4">
        <li class="c11">
          <span class="c3">Prohibited Uses.</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          You may use the Services only for lawful purposes and in accordance
          with these Terms of Use. You agree not to use the Services:
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_11-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            In any way that is unlawful (including, without limitation, any laws
            regarding the export of data or software to and from the US or other
            countries), offensive, threatening, libelous, defamatory,
            pornographic, obscene, or otherwise objectionable, or violates any
            third party&rsquo;s intellectual property rights or these Terms of
            Service.{" "}
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_12-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            To transmit, or procure the sending of, any advertising or
            promotional material, including any &ldquo;junk mail&rdquo;,
            &ldquo;chain letter&rdquo; or &ldquo;spam&rdquo; or any other
            similar solicitation.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_13-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            To impersonate or attempt to impersonate the Company, a Company
            employee, another user or any other person or entity (including,
            without limitation, by using e-mail addresses or screen names
            associated with any of the foregoing).
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_14-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            To engage in any other conduct that restricts or inhibits
            anyone&rsquo;s use or enjoyment of the Services, or which, as
            determined by us, may harm the Company or users of the Services or
            expose them to liability.
          </span>
        </li>
      </ol>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c2">Additionally, you agree not to:</span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_15-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Use the Services in any manner that could disable, overburden,
            damage, or impair the site or interfere with any other party&rsquo;s
            use of the Services, including their ability to engage in real time
            activities through the Services.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_16-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Use any robot, spider or other automatic device, process or means to
            access the Services for any purpose, including monitoring or copying
            any of the material on the Services.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_17-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Use any manual process to monitor or copy any of the material on the
            Website or for any other unauthorized purpose without our prior
            written consent.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_18-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Use any device, software or routine that interferes with the proper
            working of the Services.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_19-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Introduce any viruses, trojan horses, worms, logic bombs or other
            material which is malicious or technologically harmful.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_20-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Attempt to gain unauthorized access to, interfere with, damage or
            disrupt any parts of the Services, the server on which the Services
            are stored, or any server, computer or database connected to the
            Services.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_21-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Attack the Services via a denial-of-service attack or a distributed
            denial-of-service attack.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_22-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Otherwise attempt to interfere with the proper working of the
            Services.
          </span>
        </li>
      </ol>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="5">
        <li class="c1">
          <span class="c3">USER CONTRIBUTIONS.&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c7">
          The Website may contain message boards, chat rooms, personal web pages
          or profiles, forums, bulletin boards, player score information, army
          information, and other interactive features (collectively,{" "}
        </span>
        <span class="c7 c9">&ldquo;Interactive Services&rdquo;</span>
        <span class="c7">
          ) that allow users to post, submit, publish, display or transmit to
          other users or other persons (hereinafter,{" "}
        </span>
        <span class="c7 c9">&ldquo;post&rdquo;</span>
        <span class="c7">) content or materials (collectively, </span>
        <span class="c7 c9">&ldquo;User Contributions&rdquo;</span>
        <span class="c2">
          ) on or through the Services for display on the Website.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          All User Contributions must comply with the Content Standards set out
          in these Terms of Use. &nbsp;Any User Contribution you post to the
          site is considered non-confidential and non-proprietary. &nbsp;By
          providing any User Contribution, you grant us and our affiliates and
          service providers, and each of their and our respective licensees,
          successors and assigns the right to use, reproduce, modify, perform,
          display, distribute and otherwise disclose to third parties any such
          material for any purpose.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">You represent and warrant that:</span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_23-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            You own or control all rights in and to the User Contributions and
            have the right to grant the license granted above to us and our
            affiliates and service providers, and each of their and our
            respective licensees, successors and assigns.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_24-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            All of your User Contributions do and will comply with these Terms
            of Use.
          </span>
        </li>
      </ol>
      <p class="c4 c10 c15">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c2">
          You understand and acknowledge that you are responsible for any User
          Contributions you submit or contribute, and you, not the Company, have
          full responsibility for such content, including its legality,
          reliability, accuracy and appropriateness. &nbsp;You understand that
          the Company will attempt to review player score information for
          duplication but the Company is not responsible for the accuracy of
          such information.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c22">
        <span class="c2">
          We are not responsible, or liable to any third party, for the content
          or accuracy of any User Contributions posted by you or any other user
          of the Website.
        </span>
      </p>
      <p class="c4 c10">
        <span class="c12 c7 c9"></span>
      </p>
      <ol class="c8 lst-kix_list_46-1" start="5">
        <li class="c11">
          <span class="c3">
            Monitoring and Enforcement; Termination.&nbsp;&nbsp;
          </span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">We have the right to:</span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_25-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Remove, edit, modify or refuse to post any User Contributions for
            any or no reason in our sole discretion.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_26-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Take any action with respect to any User Contribution that we deem
            necessary or appropriate in our sole discretion.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_27-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Disclose your identity or other information about you to any third
            party who claims that material posted by you violates their rights,
            including their intellectual property rights or their right to
            privacy.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_28-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Take appropriate legal action for any illegal or unauthorized use of
            the Website.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_29-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Terminate or suspend your access to all or part of the Website for
            any or no reason, including without limitation, any violation of
            these Terms of Use.
          </span>
        </li>
      </ol>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c2">
          Without limiting the foregoing, we have the right to fully cooperate,
          in accordance with applicable law, with any law enforcement
          authorities or court order requesting or directing us to disclose the
          identity or other information of anyone posting any materials on or
          through the Website. YOU WAIVE AND HOLD HARMLESS THE COMPANY AND ITS
          AFFILIATES, LICENSEES AND SERVICE PROVIDERS FROM ANY CLAIMS RESULTING
          FROM ANY ACTION TAKEN BY BEST COAST PAIRINGS LLC DURING OR AS A RESULT
          OF ANY LAW ENFORCEMENT AUTHORITIES&rsquo; INVESTIGATIONS AND FROM ANY
          ACTIONS TAKEN AS A CONSEQUENCE OF INVESTIGATIONS BY BEST COAST
          PAIRINGS LLC OR LAW ENFORCEMENT AUTHORITIES.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          We do not screen material before it is posted on the Website and do
          not actively moderate User Contributions, so we cannot ensure prompt
          removal of objectionable material after it has been posted.
          &nbsp;Accordingly, we assume no liability for any action or inaction
          regarding transmissions, communications or content provided by any
          user or third party. We have no liability or responsibility to anyone
          for performance or nonperformance of the activities described in this
          section. &nbsp;If you have any complaints regarding another
          user&rsquo;s User Contributions, please contact us at
          support@bestcoastpairings.com.{" "}
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-1" start="6">
        <li class="c11">
          <span class="c3">Content Standards.&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          These content standards apply to any and all User Contributions and
          use of Interactive Services. User Contributions must in their entirety
          comply with all applicable federal, state, local and international
          laws and regulations. Without limiting the foregoing, User
          Contributions must be accurate and must not:
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_30-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Contain any material which is defamatory, obscene, indecent,
            abusive, offensive, harassing, violent, hateful, inflammatory or
            otherwise objectionable.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_31-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Promote any illegal activity, or advocate, promote or assist any
            unlawful act, including the promotion of sexually explicit or
            pornographic material, violence, or discrimination based on race,
            sex, religion, nationality, disability, sexual orientation or age.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_32-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Infringe any patent, trademark, trade secret, copyright or other
            intellectual property or other rights of any other person.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_33-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c7">
            Violate the legal rights (including the rights of publicity and
            privacy) of others or contain any material that could give rise to
            any civil or criminal liability under applicable laws or regulations
            or that otherwise may be in conflict with these Terms of Use and our{" "}
          </span>
          <span class="c14 c7">Privacy Policy</span>
          <span class="c7">&nbsp;</span>
          <span>https://www.bestcoastpairings.com/privacy</span>
          <span class="c2">.</span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_34-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Be likely to deceive any person or cause annoyance, inconvenience or
            needless anxiety or be likely to upset, embarrass, alarm or annoy
            any other person.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_35-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Impersonate any person, or misrepresent your identity or affiliation
            with any person or organization.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_36-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Involve commercial activities or sales, such as contests,
            sweepstakes and other sales promotions, barter or advertising.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_37-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Give the impression that they emanate from or are endorsed by us or
            any other person or entity.
          </span>
        </li>
      </ol>
      <p class="c4 c10">
        <span class="c12 c7 c9"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="6">
        <li class="c1">
          <span class="c3">COPYRIGHT INFRINGEMENT.&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c7">
          We take claims of copyright infringement seriously. &nbsp;We will
          respond to notices of alleged copyright infringement that comply with
          applicable law. &nbsp;If you believe any materials accessible on or
          from the Services (including the Website) infringe your copyright, you
          may request removal of those materials (or access to them) from the
          Services by submitting written notification to us at{" "}
        </span>
        <span class="c16 c19">
          <a class="c21" href="mailto:support@bestcoastpairings.com">
            support@bestcoastpairings.com
          </a>
        </span>
        <span class="c2">
          . &nbsp;It is the Company&rsquo;s policy to terminate the user
          accounts of repeat infringers.
        </span>
      </p>
      <p class="c4 c10">
        <span class="c7 c9 c12"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="7">
        <li class="c1">
          <span class="c3">RELIANCE ON INFORMATION POSTED.&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          The information presented on or through the Website is made available
          solely for general information purposes. We do not warrant the
          accuracy, completeness or usefulness of this information. Any reliance
          you place on such information is strictly at your own risk. We
          disclaim all liability and responsibility arising from any reliance
          placed on such materials by you or any other visitor to the Website,
          or by anyone who may be informed of any of its contents.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          This Website includes content provided by third parties, including
          materials provided by other users, bloggers and third-party licensors,
          syndicators, aggregators and/or reporting services. All information,
          statements and/or opinions expressed in these materials, and all
          articles and responses to questions and other content, other than the
          content provided by the Company, are solely the opinions and the
          responsibility of the person or entity providing those materials.
          These materials do not necessarily reflect the opinion of the Company.
          We are not responsible, or liable to you or any third party, for the
          content or accuracy of any materials provided by any third parties.
        </span>
      </p>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c7">
          The Website, including Best Coast Pairings Rankings (&ldquo;
        </span>
        <span class="c7 c9">BCP Rankings</span>
        <span class="c2">
          &rdquo;), is provided and intended for informational and entertainment
          purposes only, and no Services provided by us are a contest,
          sweepstakes, lottery, gambling, or controlled game, as defined by
          California law. &nbsp;No &ldquo;thing of value&rdquo; (which under
          California law includes any money, coin, currency, check, chip,
          allowance, token, credit, merchandise, property, or any representative
          of value), or prizes (monetary or otherwise) are promised or implied
          by BCP through the BCP Rankings or this Website. &nbsp;As set forth in
          the Website Terms of Use and other applicable license, BCP reserves
          the right to alter or change the Services, the Website, and BCP
          Rankings as it deems fit.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="8">
        <li class="c1">
          <span class="c3">CHANGES TO THE WEBSITE.&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          We may update the content available through the Services from time to
          time, but its content is not necessarily complete or up-to-date. Any
          of the material available through the Services may be out of date at
          any given time, and we are under no obligation to update such
          material. &nbsp;From time to time, the Company may issue an update to
          the Services, which may add, modify, and/or remove features; these
          updates may be pushed out automatically with little or no notice.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="9">
        <li class="c1">
          <span class="c3">
            INFORMATION ABOUT YOU AND YOUR VISITS TO THE WEBSITE.&nbsp;&nbsp;
          </span>
        </li>
      </ol>
      <p class="c4">
        <span class="c7">
          All information we collect through the Services is subject to our{" "}
        </span>
        <span class="c14 c7">Privacy Policy</span>
        <span class="c7">&nbsp;</span>
        <span class="c16 c17">
          <a
            class="c21"
            href="https://www.google.com/url?q=https://www.bestcoastpairings.com/privacy&amp;sa=D&amp;source=editors&amp;ust=1643111868088753&amp;usg=AOvVaw1OXV2Wq_qGFyo4KqM_K8SN"
          >
            https://www.bestcoastpairings.com/privacy
          </a>
        </span>
        <span>&nbsp;</span>
        <span class="c2">
          . By visiting the Website and using the Services, you consent to all
          actions taken by us with respect to your information in compliance
          with the Privacy Policy.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="10">
        <li class="c1">
          <span class="c3">
            ONLINE PURCHASES AND OTHER TERMS AND CONDITIONS.&nbsp;
          </span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          All purchases through our Services or other transactions for the sale
          of services or information formed through the Services or as a result
          of visits made by you are governed by our end user license agreement
          for the Tournament Application or Player Application (as applicable),
          which are hereby incorporated into these Terms of Use.
          &nbsp;Additional terms and conditions may also apply to specific
          portions, services or features of the Services, including without
          limitation other subscription or license agreement(s) entered into by
          the parties. All such additional terms and conditions are hereby
          incorporated by this reference into these Terms of Use. &nbsp;To the
          extent any conflict exists between these Terms of Use, the
          Subscription Agreement, or the End User License Agreement, the
          following order of precedence shall apply: (1) Subscription Agreement
          or other license agreement entered into by the parties; (2) End User
          License Agreement; and (3) these Terms of Use. &nbsp;The Privacy
          Policy shall control with respect to all matters of privacy and data
          processing.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="11">
        <li class="c1">
          <span class="c3">
            LINKING TO THE WEBSITE AND SOCIAL MEDIA FEATURES.&nbsp;&nbsp;
          </span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          You may link to our homepage, provided you do so in a way that is fair
          and legal and does not damage our reputation or take advantage of it,
          but you must not establish a link in such a way as to suggest any form
          of association, approval or endorsement on our part without our
          express written consent.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          This Website may provide certain social media features that enable you
          to:
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_38-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Link from your own or certain third-party websites to certain
            content on this Website.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_39-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Send e-mails or other communications with certain content, or links
            to certain content, on this Website.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_40-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Cause limited portions of content on this Website to be displayed or
            appear to be displayed on your own or certain third-party websites.
          </span>
        </li>
      </ol>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c2">
          You may use these features solely as they are provided by us with
          respect to the content they are displayed with and otherwise in
          accordance with any additional terms and conditions we provide with
          respect to such features. Subject to the foregoing, you must not:
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <ol class="c8 lst-kix_list_41-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Establish a link from any website that is not owned by you.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_42-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Cause the Website or portions of it to be displayed, or appear to be
            displayed by, for example, framing, deep linking or in-line linking,
            on any other site.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_43-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Link to any part of the Website other than the homepage.
          </span>
        </li>
      </ol>
      <ol class="c8 lst-kix_list_44-0 start" start="1">
        <li class="c0 li-bullet-0">
          <span class="c2">
            Otherwise take any action with respect to the materials available
            through the Services that is inconsistent with any other provision
            of these Terms of Use.
          </span>
        </li>
      </ol>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c2">
          You agree to cooperate with us in causing any unauthorized framing or
          linking immediately to cease. We reserve the right to withdraw linking
          permission without notice. &nbsp;We may disable all or any social
          media features and any links at any time without notice in our
          discretion.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="12">
        <li class="c1">
          <span class="c3">LINKS FROM OUR WEBSITE&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          If the Services contain links to other sites and resources provided by
          third parties, these links are provided for your convenience only.
          This includes links contained in advertisements, including banner
          advertisements and sponsored links. We have no control over the
          contents of those sites or resources, and accept no responsibility for
          them or for any loss or damage that may arise from your use of them.
          If you decide to access any of the third party websites linked to the
          Services, you do so entirely at your own risk and subject to the terms
          and conditions of use for such websites.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="13">
        <li class="c1">
          <span class="c3">GEOGRAPHIC RESTRICTIONS&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          The owner of the Website is based in the state of California in the
          United States. We make no claims that the Services or any of its
          content is accessible or appropriate outside of the United States.
          Access to the Website may not be legal by certain persons or in
          certain countries. If you access the Website from outside the United
          States, you do so on your own initiative and are responsible for
          compliance with local laws.
        </span>
      </p>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="14">
        <li class="c1">
          <span class="c3">DISCLAIMER OF WARRANTIES&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          You understand that we cannot and do not guarantee or warrant that
          files available for downloading from the internet or the Services will
          be free of viruses or other destructive code. You are responsible for
          implementing sufficient procedures and checkpoints to satisfy your
          particular requirements for anti-virus protection and accuracy of data
          input and output, and for maintaining a means external to our site for
          any reconstruction of any lost data. WE WILL NOT BE LIABLE FOR ANY
          LOSS OR DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK,
          VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR
          COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA OR OTHER PROPRIETARY
          MATERIAL DUE TO YOUR USE OF THE WEBSITE OR ANY SERVICES OR ITEMS
          OBTAINED THROUGH THE SERVICES OR TO YOUR DOWNLOADING OF ANY MATERIAL
          POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          YOUR USE OF THE SERVICES, ITS CONTENT AND ANY SERVICES OR ITEMS
          OBTAINED THROUGH THE SERVICES IS AT YOUR OWN RISK. THE SERVICES, ITS
          CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE SERVICES ARE
          PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo;
          BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
          NEITHER THE COMPANY NOR ANY PERSON ASSOCIATED WITH THE COMPANY MAKES
          ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS,
          SECURITY, RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE
          WEBSITE. WITHOUT LIMITING THE FOREGOING, NEITHER THE COMPANY NOR
          ANYONE ASSOCIATED WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE
          SERVICES, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE
          SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE OR UNINTERRUPTED, THAT
          DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES IT
          AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE
          SERVICES, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE
          SERVICES WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          THE COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER
          EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED
          TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR
          PARTICULAR PURPOSE. &nbsp;THE FOREGOING DOES NOT AFFECT ANY WARRANTIES
          WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
        </span>
      </p>
      <p class="c4 c10">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="15">
        <li class="c1">
          <span class="c3">LIMITATION ON LIABILITY&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          IN NO EVENT WILL THE MAXIMUM AGGREGATE LIABILITY OF THE COMPANY AND
          AFFILIATES, AND THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS,
          OFFICERS AND DIRECTORS, TO ANY PARTY (REGARDLESS OF THE FORM OF
          ACTION, WHETHER IN CONTRACT, TORT OR OTHERWISE) EXCEED THE AMOUNT YOU
          HAVE PAID TO THE COMPANY FOR ACCESS TO THE APPLICABLE SERVICES IN THE
          SIX MONTHS PRECEDING THE CLAIM GIVING RISE TO SUCH LIABILITY.
          &nbsp;THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE
          EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="16">
        <li class="c1">
          <span class="c3">INDEMNIFICATION&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          You agree to defend, indemnify and hold harmless the Company, its
          affiliates, licensors and service providers, and its and their
          respective officers, directors, employees, contractors, agents,
          licensors, suppliers, successors and assigns from and against any
          claims, liabilities, damages, judgments, awards, losses, costs,
          expenses or fees (including reasonable attorneys&rsquo; fees) arising
          out of or relating to your violation of these Terms of Use or your use
          of the Services, including, but not limited to, your User
          Contributions, any use of the Website&rsquo;s content, services and
          products other than as expressly authorized in these Terms of Use or
          your use of any information obtained from the Services.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="17">
        <li class="c1">
          <span class="c3">GOVERNING LAW AND JURISDICTION&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          All matters relating to the Services and the Terms of Use and any
          dispute or claim arising therefrom or related thereto (in each case,
          including non-contractual disputes or claims), shall be governed by
          and construed in accordance with the laws of the State of California
          without giving effect to any choice or conflict of law provision or
          rule. &nbsp;Any legal suit, action or proceeding arising out of, or
          related to, the Terms of Use or the Services shall be instituted
          exclusively in the federal courts of the United States or the courts
          of the State of California although we retain the right to bring any
          suit, action or proceeding against you for breach of these Terms of
          Use in your country of residence or any other relevant country. You
          waive any and all objections to the exercise of jurisdiction over you
          by such courts and to venue in such courts.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="18">
        <li class="c1">
          <span class="c3">LIMITATION ON TIME TO FILE CLAIMS</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING
          TO THE TERMS OF USE OR THE SERVICES MUST BE COMMENCED WITHIN ONE (1)
          YEAR AFTER THE CAUSE OF ACTION ACCRUES, OTHERWISE, SUCH CAUSE OF
          ACTION OR CLAIM IS PERMANENTLY BARRED.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="19">
        <li class="c1">
          <span class="c3">WAIVER AND SEVERABILITY&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          No waiver by the Company of any term or condition set forth in these
          Terms of Use shall be deemed a further or continuing waiver of such
          term or condition or a waiver of any other term or condition, and any
          failure of the Company to assert a right or provision under these
          Terms of Use shall not constitute a waiver of such right or provision.
          &nbsp;If any provision of these Terms of Use is held by a court or
          other tribunal of competent jurisdiction to be invalid, illegal or
          unenforceable for any reason, such provision shall be eliminated or
          limited to the minimum extent such that the remaining provisions of
          the Terms of Use will continue in full force and effect.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <ol class="c8 lst-kix_list_46-0" start="20">
        <li class="c1">
          <span class="c3">ENTIRE AGREEMENT&nbsp;&nbsp;</span>
        </li>
      </ol>
      <p class="c4">
        <span class="c2">
          The Terms of Use and our Privacy Policy constitute the sole and entire
          agreement between you and Best Coast Pairings LLC with respect to the
          Website and supersede all prior and contemporaneous understandings,
          agreements, representations and warranties, both written and oral,
          with respect to the Website.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <p class="c4">
        <span class="c7 c9 c16">Your Comments and Concerns</span>
        <span class="c2">&nbsp;&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          This Website and the Services are operated by Best Coast Pairings LLC.
        </span>
      </p>
      <p class="c4">
        <span class="c2">&nbsp;</span>
      </p>
      <p class="c4">
        <span class="c2">
          All other feedback, comments, requests for technical support and other
          communications relating to the Website should be directed to:
          support@bestcoastpairings.com.
        </span>
      </p>
      <p class="c5">
        <span class="c2"></span>
      </p>
      <div>
        <p class="c13 c10">
          <span class="c7 c23"></span>
        </p>
      </div>
    </Container>
  );
}
